'use strict';

import React from 'react';

class SearchInput extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className='search-suggester-input-container'>
                <label htmlFor="search-suggester-input" className="search-suggester-label">Search</label>
                <form action={this.props.formAction} method="GET">
                    <input onKeyUpCapture={this.props.onKeyPress}
                           name='Search'
                           autoComplete="off"
                           className="search-suggester-input"
                           id='search-suggester-input'
                           aria-autocomplete="list"
                           aria-controls="#suggestive-search-suggestions-container"/>
                    {this.props.formAction.length > 0 ? <input type="submit" name="Submit" value='Search' className='sr-only'/> : ''}
                </form>
            </div>
        );
    }
}

export default SearchInput;
